<template>
  <div class="flex flex-col gap-2 h-full overflow-hidden">
    <ThreadsNav show-back :show-center="false">
      <template #right>
        <GoInteractionHistory
          v-if="relationMateIdPair"
          class="btn btn-xs"
          :source-mate-id="relationMateIdPair.sourceMateId"
          :target-mate-id="relationMateIdPair.targetMateId"
        />
      </template>
    </ThreadsNav>
    <div class="flex-1 overflow-auto px-4">
      <MateMailItem
        v-if="mateMail"
        :mail="mateMail"
        :type="type"
        show-detail
        @reload="reload"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useInteractive } from "@/stores/interactive";
import { MateMail } from "@/types/entity";
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { MateMailType } from "@/enums/mateEnums";
import { useMate } from "@/stores/mate";
import { useNotification } from "@/stores/notification";

const mateMail = ref<MateMail>();
const interactiveStore = useInteractive();
const route = useRoute();
const mateStore = useMate();

const type = ref<MateMailType>(MateMailType.Inbox);

const relationMateIdPair = computed<{
  sourceMateId: number;
  targetMateId: number;
} | null>(() => {
  if (!mateMail.value) {
    return null;
  }
  if (mateMail.value.senderId === mateMail.value.recipientId) {
    return null;
  }
  if (mateStore.isMyMateById(mateMail.value.senderId)) {
    return {
      sourceMateId: mateMail.value.senderId,
      targetMateId: mateMail.value.recipientId,
    };
  }
  return {
    sourceMateId: mateMail.value.recipientId,
    targetMateId: mateMail.value.senderId,
  };
});

onMounted(async () => {
  const { uuid } = route.params;
  const { type: _type } = route.query;
  if (uuid) {
    const mail = await interactiveStore.getMail(uuid as string);
    if (mail) {
      mateMail.value = mail;
      if (!mail.dtRead) {
        mail.dtRead = new Date().toISOString();
        interactiveStore.readMail(mail.id);
        interactiveStore.homeNeedReload = true;

        const notificationStore = useNotification();
        if (
          notificationStore.interactionSummary &&
          notificationStore.interactionSummary.unreadMailCount > 0
        ) {
          notificationStore.initSummaryCount();
        }
      }
    }
  }

  if (_type) {
    type.value = _type as MateMailType;
  }
});

const reload = () => {
  interactiveStore.homeNeedReload = true;
};
</script>
